
import { DateWiseTokenConsumptionModel } from "./date-wise-token-cons.model"

export class EmployeeTokenConsumptionReportModel {
    employeeName: string;
    employeeCode: string;
    department: string;
    tokenType: string;
    dateWiseConsumption: DateWiseTokenConsumptionModel[];
    unitCost:  number;
    totalCost: number;
    totalSubsidy: number

    /**
     * 
     * @param employeeName 
     * @param employeeCode 
     * @param department 
     * @param tokenType 
     * @param dateWiseConsumption 
     * @param unitCost 
     * @param totalCost 
     * @param totalSubsidy 
     */
    constructor(employeeName: string, employeeCode: string, department: string, tokenType: string, dateWiseConsumption: DateWiseTokenConsumptionModel[], unitCost:  number, totalCost: number, totalSubsidy: number) {
        this.employeeName = employeeName;
        this.employeeCode = employeeCode;
        this.department = department;
        this.tokenType = tokenType;
        this.dateWiseConsumption = dateWiseConsumption;
        this.unitCost = unitCost;
        this.totalCost = totalCost;
        this.totalSubsidy = totalSubsidy;
    }
}

